export default "__VITE_ASSET__DbZHS_5z__"